const packageName = 'settings'

export const TOGGLE_MENU = `${packageName}/TOGGLE_MENU`
